export const UpdateSpaceGroupPermissionService = Symbol('UpdateSpaceGroupPermissionService');
export const QuerySpaceGroupPermissionService = Symbol('QuerySpaceGroupPermissionService');
